export default "__VITE_PUBLIC_ASSET__777468ed__"